import common from './common.json';
import forms from './forms.json';
import sidebar from './sidebar.json';
import news from './news.json';
import members from './members.json';
import feed from './feed.json';
import modules from './modules.json';
import association from './association.json';
import contentPages from './content-pages.json';
import competitions from './competitions.json';
import authorization from './authorization.json';
import permissions from './permissions.json';
import panels from './panels.json';
import activities from './activities.json';
import userMenu from './user-menu.json';
import components from './components.json';
import notifications from './notifications.json';
import shooting from './shooting.json';

export const nl = {
  translation: common,
  forms,
  sidebar,
  news,
  members,
  feed,
  modules,
  association,
  contentPages,
  competitions,
  authorization,
  permissions,
  panels,
  activities,
  userMenu,
  components,
  notifications,
  shooting,
};
